"use client";
import { apis } from "@/static/apis/apis";
import { StateEveryType } from "@/types/global";
import { AdvertisementType } from "@/types/requests/advertizment";
import { Axios, AxiosPromise } from "axios";
import { useState } from "react";
import { Dispatch, SetStateAction } from "react";
import toast from "react-hot-toast";
interface AnyObject {
  [key: string]: any;
}

const getData = async <T extends AnyObject>(
  api: string,
  axios: Axios,
  setData?: Dispatch<SetStateAction<StateEveryType<AnyObject>>>,
  toastMessage: boolean | string = false,
  successOp = (res?: any) => {},
  errorOp = () => {},
  params: AnyObject = {}
) => {
  try {
    const res = await axios.get(api, { params: params });
    if (setData !== undefined) {
      await setData((x: any) => ({ ...x, data: res.data, loading: false }));
    }
    if (typeof toastMessage === "string") {
      toast.success(toastMessage);
    } else if (toastMessage) toast.success("انجام شد");
    successOp(res);
    return res.data;
  } catch (e) {
    if (setData !== undefined)
      setData((x: any) => ({ ...x, error: e, loading: false }));
    errorOp();
    return e;
  }
};
export default getData;
